import React from 'react';

// --- 1. DATI DEL PROGRAMMA (Hardcoded) ---
const localProgramData = [
  // --- INIZIO GIORNATA ---
  {
    id: 1,
    Orario: "08:30",
    Titolo: "Registrazione partecipanti",
    TipoVoce: "Registrazione",
    Sessione: "Mattina",
  },
  {
    id: 2,
    Orario: "08:45",
    Titolo: "Saluto dei responsabili",
    TipoVoce: "Saluti",
    Sessione: "Mattina",
  },
  {
    id: 3,
    Orario: "08:50",
    Titolo: "Saluti Presidenza CIF Regionale",
    Relatore: "Prof.ssa M. Gargiulo",
    TipoVoce: "Saluti",
    Sessione: "Mattina",
  },
  {
    id: 4,
    Orario: "08:55",
    Titolo: "Saluti Presidenza CIF Provinciale",
    Relatore: "Dott.ssa F. Girace",
    TipoVoce: "Saluti",
    Sessione: "Mattina",
  },
  {
    id: 5,
    Orario: "09:00",
    Titolo: "Saluti Presidenza CIF Comunale",
    Relatore: "Prof.ssa M.A. Zampella",
    TipoVoce: "Saluti",
    Sessione: "Mattina",
  },

  // --- SESSIONE 1 (Mattina) ---
  {
    id: 6,
    Orario: null, // Moderazione senza orario a sinistra
    Titolo: "Moderazione Sessione 1",
    TipoVoce: "Moderazione",
    Sessione: "Mattina",
    Moderatori: "Cecilia Politi, Pierpaolo Di Micco",
  },
  {
    id: 7,
    Orario: "09:10",
    Titolo: "La presenza delle donne nel Sistema Sanitario Nazionale",
    Relatore: "Maria Gabriella Coppola",
    TipoVoce: "Conferenza",
    Sessione: "Mattina",
  },
  {
    id: 8,
    Orario: "09:25",
    Titolo: "Anomalie metaboliche del pz diabetico con TEV",
    Relatore: "Ada Maffettone",
    TipoVoce: "Conferenza",
    Sessione: "Mattina",
  },
  {
    id: 9,
    Orario: "09:40",
    Titolo: "Trombosi vacciniche e loro aggregazione nel sesso femminile",
    Relatore: "Maria Giovanna Di Palo",
    TipoVoce: "Conferenza",
    Sessione: "Mattina",
  },
  {
    id: 10,
    Orario: "09:55",
    Titolo: "Omocisteina, fabbisogno di folati e effetti clinici nelle donne",
    Relatore: "Antonella Tufano",
    TipoVoce: "Conferenza",
    Sessione: "Mattina",
  },
  {
    id: 11,
    Orario: "10:10",
    Titolo: "Discussione",
    TipoVoce: "Discussione",
    Sessione: "Mattina",
  },
  {
    id: 12,
    Orario: "10:30",
    Titolo: "Coffee Break",
    TipoVoce: "Coffee Break",
    Sessione: "Mattina",
  },

  // --- SESSIONE 2 (Mappata come 'Pomeriggio' per attivare l'header Sessione 2) ---
  {
    id: 13,
    Orario: null,
    Titolo: "Moderazione Sessione 2",
    TipoVoce: "Moderazione",
    Sessione: "Pomeriggio",
    Moderatori: "Maria D’Avino, Raffaele A.N. Ranucci",
  },
  {
    id: 14,
    Orario: "11:05",
    Titolo: "Antibioticoprofilassi post operatoria e medicina di genere",
    Relatore: "Nicolina Capoluongo",
    TipoVoce: "Conferenza",
    Sessione: "Pomeriggio",
  },
  {
    id: 15,
    Orario: "11:20",
    Titolo: "Trattamenti Anti-Ageing: Nuove evidenze farmacologiche",
    Relatore: "Armando Scimone",
    TipoVoce: "Conferenza",
    Sessione: "Pomeriggio",
  },
  {
    id: 16,
    Orario: "11:35",
    Titolo: "Human Beta Defensin e loro applicabilità in angiologia",
    Relatore: "Prof.ssa Olga Scudiero",
    TipoVoce: "Conferenza",
    Sessione: "Pomeriggio",
  },
  {
    id: 17,
    Orario: "11:50",
    Titolo: "Uso secondario di dati sanitari elettronici e medicina di genere",
    Relatore: "Prof.ssa Ilaria Caggiano",
    TipoVoce: "Conferenza",
    Sessione: "Pomeriggio",
  },
  {
    id: 18,
    Orario: "12:05",
    Titolo: "Discussione",
    TipoVoce: "Discussione",
    Sessione: "Pomeriggio",
  },

  // --- PREMIAZIONI ---
  {
    id: 19,
    Orario: "12:30",
    Titolo: "Premio alla Dott.ssa Ada Maffettone",
    Relatore: "Prof.ssa Cecilia Politi", // Chi premia
    Descrizione: "Per le molteplici iniziative formative per le donne medico.",
    TipoVoce: "Premiazione",
    Sessione: "Pomeriggio",
  },
  {
    id: 20,
    Orario: "12:45",
    Titolo: "Premio alla Dott.ssa Maria Amitrano",
    Relatore: "Prof.ssa Antonella Tufano", // Chi premia
    Descrizione: "Per la ricerca sul metabolismo del ferro nelle flebopatie.",
    TipoVoce: "Premiazione",
    Sessione: "Pomeriggio",
  },

  // --- CHIUSURA ---
  {
    id: 21,
    Orario: "13:00",
    Titolo: "Questionario ECM",
    TipoVoce: "Questionario ECM",
    Sessione: "Pomeriggio",
  }
];

// --- 2. HELPER TEXT ---
const RichTextRenderer = ({ blocks }) => {
  if (!blocks) return null;
  if (typeof blocks === 'string') {
    return <p className="text-sm text-gray-600 ml-4 mt-1">{blocks}</p>;
  }
  if (Array.isArray(blocks)) {
    return blocks.map((block, index) => {
      if (block.type === 'paragraph' && Array.isArray(block.children)) {
        return (
          <p key={index} className="text-sm text-gray-600 ml-4 mt-1">
            {block.children.map((child, childIndex) => (
              <span key={childIndex}>{child.text}</span>
            ))}
          </p>
        );
      }
      return null;
    });
  }
  return null;
};

// --- 3. HELPER LAYOUT VOCI ---
const ProgramItem = ({ item }) => {
  const { Orario, Titolo, Relatore, Descrizione, TipoVoce } = item;

  // Gestione sicura dell'orario
  const orarioFormattato = (typeof Orario === 'string') ? Orario.substring(0, 5) : '';

  switch (TipoVoce) {
    case 'Conferenza':
      return (
        <li className="flex flex-row items-start mb-4">
          <span className="w-20 font-bold text-gray-800 text-right pr-4 flex-shrink-0">{orarioFormattato}</span>
          <div className="flex-1 border-l-4 border-blue-500 pl-4">
            <strong className="text-gray-900">{Titolo}</strong>
            {Relatore && <p className="text-sm text-gray-500">Relatore: {Relatore}</p>}
          </div>
        </li>
      );

    case 'Premiazione':
      return (
        <li className="flex flex-row items-start mb-4">
          <span className="w-20 font-bold text-gray-800 text-right pr-4 flex-shrink-0">{orarioFormattato}</span>
          <div className="flex-1 border-l-4 border-purple-500 pl-4">
            <strong className="text-gray-900">{Titolo}</strong>
            {Relatore && <p className="text-sm text-gray-500">Premiato da: {Relatore}</p>}
            <RichTextRenderer blocks={Descrizione} />
          </div>
        </li>
      );

    case 'Area Espositiva':
        return (
          <li className="flex flex-row items-start mb-4">
            <span className="w-20 font-bold text-gray-800 text-right pr-4 flex-shrink-0"></span>
            <div className="flex-1 border-l-4 border-green-500 pl-4">
              <strong className="text-gray-900">{Titolo}</strong>
            </div>
          </li>
        );

    case 'Registrazione':
    case 'Saluti':
    case 'Discussione':
    case 'Coffee Break':
    case 'Questionario ECM':
      return (
        <li className="flex flex-row items-start mb-4">
          <span className="w-20 font-bold text-gray-800 text-right pr-4 flex-shrink-0">{orarioFormattato}</span>
          <div className="flex-1 border-l-4 border-gray-400 pl-4">
            <strong className="text-gray-700">{Titolo}</strong>
            {Relatore && <p className="text-sm text-gray-500">{Relatore}</p>}
          </div>
        </li>
      );

    case 'Moderazione':
    default:
      return null;
  }
};


// --- 4. COMPONENTE PRINCIPALE ---
const ProgramPage = () => {
  
  // Ordiniamo i dati (il campo Orario è stringa "HH:mm", quindi ordinamento alfabetico funziona)
  const sortedItems = [...localProgramData].sort((a, b) => {
    if (!a.Orario) return 1;
    if (!b.Orario) return -1;
    return a.Orario.localeCompare(b.Orario);
  });

  let hasRenderedMattinaHeader = false;
  let hasRenderedPomeriggioHeader = false;
  let hasRenderedPremiazioniHeader = false;
  let hasRenderedAreaEspositivaHeader = false;

  const getModeratori = (sessione) => {
    const modItem = sortedItems.find(item => 
      item.TipoVoce === 'Moderazione' && item.Sessione === sessione
    );
    return modItem ? modItem.Moderatori : null;
  };

  return (
    <div className="bg-white p-8 rounded-2xl shadow-xl mb-12">
      <h2 className="text-3xl font-bold text-gray-800 mb-6 border-b-4 border-blue-500 pb-2">
        Programma del V Convegno Flebologia e Medicina di Genere
      </h2>

      <div className="space-y-4">
        <ul className="list-none m-0 p-0">
          {sortedItems.map((item) => {
            let sessionHeader = null;
            
            // Header Sessione 1
            if (item.Sessione === 'Mattina' && !hasRenderedMattinaHeader) {
              hasRenderedMattinaHeader = true;
              const moderatoriMattina = getModeratori('Mattina');
              sessionHeader = (
                <div className="mt-6 mb-4">
                  <h3 className="text-2xl font-semibold text-gray-800 mb-2">Mattina: Sessione 1</h3>
                  {moderatoriMattina && (
                    <p className="text-gray-600 mb-4">Moderatori: {moderatoriMattina}</p>
                  )}
                </div>
              );
            }
            // Header Sessione 2 (Triggerato da item.Sessione === 'Pomeriggio')
            else if (item.Sessione === 'Pomeriggio' && !hasRenderedPomeriggioHeader) {
              hasRenderedPomeriggioHeader = true;
              const moderatoriPomeriggio = getModeratori('Pomeriggio');
              sessionHeader = (
                <div className="mt-8 pt-4 border-t border-gray-200 mb-4">
                  <h3 className="text-2xl font-semibold text-gray-800 mb-2">Sessione 2</h3>
                  {moderatoriPomeriggio && (
                    <p className="text-gray-600 mb-4">Moderatori: {moderatoriPomeriggio}</p>
                  )}
                </div>
              );
            }
            // Header Premiazioni
            else if (item.TipoVoce === 'Premiazione' && !hasRenderedPremiazioniHeader) {
              hasRenderedPremiazioniHeader = true;
              sessionHeader = (
                <div className="mt-8 pt-4 border-t border-gray-200 mb-4">
                  <h3 className="text-2xl font-semibold text-gray-800 mb-2">Premiazioni</h3>
                </div>
              );
            }
            // Header Area Espositiva
            else if (item.TipoVoce === 'Area Espositiva' && !hasRenderedAreaEspositivaHeader) {
              hasRenderedAreaEspositivaHeader = true;
              sessionHeader = (
                <div className="mt-8 pt-4 border-t border-gray-200 mb-4">
                  <h3 className="text-2xl font-semibold text-gray-800 mb-2">Area Espositiva Artistica</h3>
                </div>
              );
            }

            return (
              <React.Fragment key={item.id}>
                {sessionHeader}
                <ProgramItem item={item} />
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ProgramPage;